import React, { useRef, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
    setCartAddressClear,
    streetChanged,
    updateCartAddress,
    updateCartEntrance,
    updateCartFlat,
    updateCartFloor,
    updateCartIntercom
} from "../../_core/cartActions";
import { changePopupProps } from "../../../common/popups/_core/popupActions";
import { cartSelectors } from "../../_core/cartSelectors";
import { AddressAdditionalInput } from "./AddressAdditionalInput";
import { AddressHouseSelectInput } from "../../../address/addressFormComponents/AddressHouseSelectInput";
import { AddressStreetSelectInput } from "../../../address/addressFormComponents/AddressStreetSelectInput";
import { catalogSelectors } from "../../../catalogs/_core/catalogSelectors";
import { ROUTES } from "../../../../system/router/routeConstants";
import { useHistory } from "react-router-dom";


const SELECT_STYLES = {
    control: {
        border: '2px solid #637c6c',
    },
};


export const AddressInput = React.memo(() => {
    const dispatch = useDispatch();
    const history = useHistory();
    const address = useSelector(cartSelectors.address);
    const isPickup = useSelector(cartSelectors.isPickup);
    const manufactures = useSelector(catalogSelectors.pickupManufactures);

    const [isStreetSelectOpen, setIsStreetSelectOpen] = useState(false);
    const [isHouseSelectOpen, setIsHouseSelectOpen] = useState(false);
    const [focusHouseInput, setFocusHouseInput] = useState(false);
    const [forceEnableHouse, setForceEnableHouse] = useState(false);
    const houseSelectRef = useRef(null);

    const [house, setHouse] = useState({
        value: address?.houseId,
        label: address?.house,
    });

    const handleStreetChange = ({label, value}) => {
        console.log('Street selected:', {label, value});
        setForceEnableHouse(true);

        dispatch(streetChanged({
            street: label,
            streetId: value
        }));

        setHouse({
            value: null,
            label: null,
        });

        setTimeout(() => {
            console.log('Opening house select');
            setIsHouseSelectOpen(true);
            setFocusHouseInput(true);
        }, 200);
    };

    const handleHouseChange = ({label, value}) => {
        console.log('House selected:', {label, value});

        setIsHouseSelectOpen(false);
        setForceEnableHouse(false);

        setHouse({label, value});

        dispatch(updateCartAddress({
            house: label,
            house_id: value,
            street: address.street,
            street_id: address.streetId,
        }));
    };

    const onSelectOpen = () => {
        setIsStreetSelectOpen(true);
    };

    const onSelectClose = () => {
        setIsStreetSelectOpen(false);
    };

    const onHouseSelectClose = () => {
        console.log('onHouseSelectClose called');
        setIsHouseSelectOpen(false);
        setForceEnableHouse(false);
    };

    useEffect(() => {
        if (focusHouseInput && houseSelectRef.current) {
            console.log('Focusing house input');
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    setTimeout(() => {
                        houseSelectRef.current?.focus();
                        setFocusHouseInput(false);
                    }, 100);
                });
            });
        }
    }, [focusHouseInput]);

    useEffect(() => {
        setHouse({
            value: address?.houseId,
            label: address?.house,
        });
    }, [address?.houseId, address?.house]);

    const handlePickupClick = (e) => {
        e.preventDefault();
        history.push(ROUTES.popups.shipping)
        dispatch(changePopupProps({
            props: {
                tab: 'pickup'
            }
        }))
    };

    const isHouseDisabled = !address?.streetId;

    console.log('Current state:', {
        address: {
            streetId: address?.streetId,
            street: address?.street,
        },
        forceEnableHouse,
        isHouseDisabled,
        isHouseSelectOpen,
        focusHouseInput
    });

    const handleStreetClear = () => {
        dispatch(setCartAddressClear({
            street: null,
            street_id: null,
            house: null,
            house_id: null,
        }));

    };

    return (
        <div className="form-group">
            <div className="form-grid form-grid--sps-normal form-grid--address">

                <div className="form-grid__cell form-size-normal form-required">
                    <div className="form-label">улица</div>
                    <AddressStreetSelectInput
                        styles={SELECT_STYLES}
                        onChange={handleStreetChange}
                        onMenuOpen={onSelectOpen}
                        onMenuClose={onSelectClose}
                        isMenuOpen={isStreetSelectOpen}
                        address={address}
                        streetClear={handleStreetClear}
                    />
                    {isPickup ? (
                        <>
                            {
                                !!manufactures.size && (
                                    <p className="form-note">Самовывоз.
                                        <a href="" onClick={handlePickupClick}> Выбрать другой адрес самовывоза</a>
                                    </p>
                                )
                            }
                        </>
                    ) : (
                        <p className="form-note">Доставка.
                            <a href="" onClick={handlePickupClick}> Изменить на самовывоз?</a>
                        </p>
                    )}
                </div>

                <div className="form-grid__cell form-grid__cell--house form-required">
                    <div className="form-label">дом</div>
                    <AddressHouseSelectInput
                        ref={houseSelectRef}
                        styles={SELECT_STYLES}
                        onChange={handleHouseChange}
                        onMenuClose={onHouseSelectClose}
                        isMenuOpen={isHouseSelectOpen}
                        disabled={!address?.streetId && !forceEnableHouse}
                        value={house}
                        autoFocus={focusHouseInput}
                    />
                </div>

                <AddressAdditionalInput value={address.flat}
                                        title="квартира"
                                        propName="flat"
                                        dispatchMethod={updateCartFlat}/>

                <AddressAdditionalInput value={address.entrance}
                                        title="подъезд"
                                        propName="entrance"
                                        dispatchMethod={updateCartEntrance}/>

                <AddressAdditionalInput value={address.floor}
                                        title="этаж"
                                        propName="floor"
                                        dispatchMethod={updateCartFloor}/>

                <AddressAdditionalInput value={address.intercom}
                                        title="домофон"
                                        propName="intercom"
                                        dispatchMethod={updateCartIntercom}/>
            </div>
        </div>
    );
});